import { render, staticRenderFns } from "./VehicleHistoryLogs.vue?vue&type=template&id=dbf9c65c&scoped=true&"
import script from "./VehicleHistoryLogs.vue?vue&type=script&lang=ts&"
export * from "./VehicleHistoryLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf9c65c",
  null
  
)

export default component.exports